module.exports = __webpack_public_path__ + "media/images/ww5-c913ca9c81a655fdc3e4594725689dfc.svg";